import React from 'react';
import SeoLandingPage from '../SeoLandingPage';

const AIScriptGeneratorLanding = () => (
  <SeoLandingPage
    testIdPrefix="tool-script"
    pretitle="AI Tool · Listing Scripts"
    title="Better listing copy"
    titleAccent="in 30 seconds"
    description="Tell us the basics — type, beds, location, price — and Shopperden AI writes you a polished listing description, a 30-second video script, and a WhatsApp/SMS share message. All in your country's voice. All clearly watermarked as AI-assisted."
    ctaLabel="Try it now"
    ctaTo="/seller/create"
    secondaryCtaLabel="For agents"
    secondaryCtaTo="/for-agents"
    bullets={[
      { title: 'Three formats', body: 'Long-form description, 30-sec video voiceover script, and a punchy WhatsApp/SMS one-liner. Pick what you need.' },
      { title: 'Country-aware', body: 'UK / India / Canada language patterns and buyer expectations baked in — no generic AI fluff.' },
      { title: 'Watermarked & honest', body: 'AI never invents features. Outputs are stamped Shopperden · AI Generated so you stay transparent with buyers.' },
    ]}
    faq={[
      { q: 'Will it write things that aren\'t true?', a: 'No. The AI is constrained to use only the facts you enter. If you don\'t list a feature, it won\'t invent one.' },
      { q: 'Can I edit the output?', a: 'Yes. AI gives you a polished first draft. You\'re free to edit, shorten, or rewrite before publishing.' },
      { q: 'Does it work in regional languages?', a: 'Indian listings can be generated in Hindi or English. UK/Canada are English by default.' },
    ]}
    seoTitle="AI Listing Script Generator — Property descriptions, video scripts & WhatsApp messages | Shopperden"
    seoDescription="AI writes polished property listing descriptions, 30-sec video scripts and WhatsApp share messages in 30 seconds. UK · India · Canada. Watermarked."
    softwareApplication={{
      name: 'Shopperden AI Listing Script Generator',
      category: 'BusinessApplication',
      subCategory: 'RealEstateApplication',
      description: 'AI-powered listing script generator: produces polished property descriptions, 30-second video scripts and WhatsApp/SMS share messages, country-aware.',
      features: [
        'Long-form listing description',
        '30-second video voiceover script',
        'WhatsApp / SMS share message',
        'UK, India, Canada language patterns',
        'Hindi & English output (India)',
      ],
      rating: { value: '4.9', count: '94' },
    }}
  />
);

export default AIScriptGeneratorLanding;
